export enum CardProviderEnum {
  PAGALO = 1,
}

export enum ICardProviderActions {
  DELETE_CARD_CONNECTION = 'DELETE_CARD_CONNECTION',
  GET_CARD_DEVICES = 'GET_CARD_DEVICES',
}

export const CardProviderName: Record<CardProviderEnum, string> = {
  [CardProviderEnum.PAGALO]: 'PAGALO',
}

export const CardProviderOptions: ISelectNumber[] = [
  { value: CardProviderEnum.PAGALO, label: CardProviderName[CardProviderEnum.PAGALO] },
]
